<!--
*****************************************
*                                       *
* NAGARRO  - CSX - CONFIDENTIAL         *
*                                       *
*****************************************
-->
<div class="pagination">Showing {{showingFrom}} to {{showingTo}} of {{totalRecords}} records</div>
<div #viewPortPaging=viewPortpaging lmsViewportPaging [child]="'data-rows'" class="yard-local-page" id="yardLocalContainer" *ngIf="user && user.isUserManagerOrDirector && loadDataToShow && loadDataToShow.length > 0" (scroll)='scrollEventOccured();' [style.height.px]='scrollHeight'
    (getPagingData)="getPaginationData($event);">
    <div [ngClass]="(stationDetail && stationDetail.stationRowNum && stationDetail.stationRowNum===1 && stationDetail.totalLine && stationDetail.totalLine.trim().length > 0)? 'data-rows' : 'data-rows  other-station'" *ngFor="let stationDetail of loadDataToShow; let i = index;">
        <div id='station-{{stationDetail?.allocStation}}-{{i}}' [ngClass]="(stationDetail?.isStationSelected)? 'allocation-station-icon selectedDraged' : 'allocation-station-icon'" (click)="setSelectedStation(stationDetail);" (contextmenu)='$event.preventDefault(); showStationContextMenu(stationDetail,i);'>
            <lms-station-icon-svg [stationDetail]='stationDetail'></lms-station-icon-svg>
        </div>
        <div class="net-alloc-div" *ngIf="stationDetail && stationDetail.stationRowNum && stationDetail.stationRowNum===1 && stationDetail.totalLine && stationDetail.totalLine.trim().length > 0">
            <div class="staion-overlay-box" (click)="showOverlay($event, op, stationDetail);">
                <span class="angel-down"></span>

                <div class="net-alloc-text">
                    <p>{{configData && configData.yardLocalLabel.netAlloc}}: {{stationDetail?.netAlloc}}</p>
                    <p>Avail vs. Plan: {{stationDetail?.availVsPlan}}</p>
                </div>

            </div>
            <p-overlayPanel #op [dismissable]="true" [showCloseIcon]="true" styleClass="staion-overlay">
                <h2 [ngClass]="stationDetail.inCompliance && stationDetail.inCompliance.trim().toLowerCase()">{{stationDetail.allocStation}}</h2>
                <ul>

                    <li> <span class="pull-left">{{configData && configData.yardLocalLabel.plan}}</span> <span class="pull-right">{{stationDetail?.plan}}</span></li>

                    <li> <span class="pull-left">{{configData && configData.yardLocalLabel.allocated}}</span> <span class="pull-right">{{stationDetail?.alloc}}</span></li>

                    <li> <span class="pull-left">{{configData && configData.yardLocalLabel.shoppedStoredOOS}}</span> <span class="pull-right"> {{stationDetail?.shopStoreOOS}}</span></li>

                    <li> <span class="pull-left">{{configData && configData.yardLocalLabel.outsideGeofence}}</span> <span class="pull-right"> {{stationDetail?.outGeo}}</span></li>

                    <li class="net-allocation">
                        <span class="pull-left">{{configData && configData.yardLocalLabel.netAllocated}}</span> <span class="pull-right"> {{stationDetail?.netAllocValue}}</span>
                        <div class="clearfix"></div>
                        <span class="pull-left plan-percent">{{configData && configData.yardLocalLabel.planPercent}}</span> <span class="pull-right plan-percent">{{stationDetail?.netAllocPercentX}}</span>
                    </li>

                    <li> <span class="pull-left">{{configData && configData.yardLocalLabel.otherYLUnit}}</span> <span class="pull-right">{{stationDetail?.otherYL}}</span></li>

                    <li> <span class="pull-left">{{configData && configData.yardLocalLabel.roadUnits}}</span> <span class="pull-right">{{stationDetail?.road}}</span></li>

                    <li class="net-allocation"> <span class="pull-left">{{configData && configData.yardLocalLabel.availableVsPlan}}</span> <span class="pull-right">{{stationDetail?.availVsPlan}}</span></li>
                </ul>
            </p-overlayPanel>
        </div>

        <div class="allocation-station-locos">
            <div [ngClass]="(stationLocoDetail?.isLocoSelected)? 'selectedDraged station-locos-divs' : (stationLocoDetail?.isLocoHighlighted?'station-locos-divs
            loco-highlighted' : 'station-locos-divs')" *ngFor="let stationLocoDetail of stationDetail.listOfLocomotives" (click)="setSelectedLoco(stationLocoDetail);" id='station-{{stationDetail?.allocStation}}-loco-{{stationLocoDetail?.locomotive}}'
                (contextmenu)='$event.preventDefault(); showLocoContextMenu(stationDetail, stationLocoDetail);'>
                <lms-loco-svg [loco]="convertStationLocoToLocoDetail(stationLocoDetail)" [isYardLocalScreen]='true'></lms-loco-svg>
            </div>
        </div>
    </div>
</div>

<!-- READ USER LEVEL ACCESS -->
<div class="yard-local-page" id="yardLocalContainer" *ngIf="user && !user.isUserManagerOrDirector && loadDataToShow && loadDataToShow.length > 0" (scroll)='scrollEventOccured();' [style.height.px]='scrollHeight'>
    <div [ngClass]="(stationDetail && stationDetail.stationRowNum && stationDetail.stationRowNum===1 && stationDetail.totalLine && stationDetail.totalLine.trim().length > 0)? 'data-rows' : 'data-rows  other-station'" *ngFor="let stationDetail of loadDataToShow; let i = index;">
        <div id='station-{{stationDetail?.allocStation}}-{{i}}' [ngClass]="'allocation-station-icon'" (contextmenu)='$event.preventDefault(); showStationContextMenu(stationDetail,i);'>
            <lms-station-icon-svg [stationDetail]='stationDetail'></lms-station-icon-svg>
        </div>
        <div class="net-alloc-div" *ngIf="stationDetail && stationDetail.stationRowNum && stationDetail.stationRowNum===1 && stationDetail.totalLine && stationDetail.totalLine.trim().length > 0">
            <div class="staion-overlay-box" (click)="showOverlay($event, op, stationDetail);">
                <span class="angel-down"></span>

                <div class="net-alloc-text">
                    <p>{{configData && configData.yardLocalLabel.netAlloc}}: {{stationDetail?.netAlloc}}</p>
                    <p>Avail vs. Plan: {{stationDetail?.availVsPlan}}</p>
                </div>

            </div>
            <p-overlayPanel #op [dismissable]="true" [showCloseIcon]="true" styleClass="staion-overlay">
                <h2 [ngClass]="stationDetail.inCompliance && stationDetail.inCompliance.trim().toLowerCase()">{{stationDetail.allocStation}}</h2>
                <ul>

                    <li> <span class="pull-left">{{configData && configData.yardLocalLabel.plan}}</span> <span class="pull-right">{{stationDetail?.plan}}</span></li>

                    <li> <span class="pull-left">{{configData && configData.yardLocalLabel.allocated}}</span> <span class="pull-right">{{stationDetail?.alloc}}</span></li>

                    <li> <span class="pull-left">{{configData && configData.yardLocalLabel.shoppedStoredOOS}}</span> <span class="pull-right"> {{stationDetail?.shopStoreOOS}}</span></li>

                    <li> <span class="pull-left">{{configData && configData.yardLocalLabel.outsideGeofence}}</span> <span class="pull-right"> {{stationDetail?.outGeo}}</span></li>

                    <li class="net-allocation"> <span class="pull-left">{{configData && configData.yardLocalLabel.netAllocated}}</span> <span class="pull-right"> {{stationDetail?.netAlloc}}</span></li>


                    <li> <span class="pull-left">{{configData && configData.yardLocalLabel.otherYLUnit}}</span> <span class="pull-right">{{stationDetail?.otherYL}}</span></li>

                    <li> <span class="pull-left">{{configData && configData.yardLocalLabel.roadUnits}}</span> <span class="pull-right">{{stationDetail?.road}}</span></li>

                    <li class="net-allocation"> <span class="pull-left">{{configData && configData.yardLocalLabel.availableVsPlan}}</span> <span class="pull-right">{{stationDetail?.availVsPlan}}</span></li>
                </ul>
            </p-overlayPanel>
        </div>

        <div class="allocation-station-locos">
            <div [ngClass]="(stationLocoDetail?.isLocoSelected)? 'selectedDraged station-locos-divs' : (stationLocoDetail?.isLocoHighlighted?'station-locos-divs
            loco-highlighted' : 'station-locos-divs')" *ngFor="let stationLocoDetail of stationDetail.listOfLocomotives" (contextmenu)='$event.preventDefault(); showLocoContextMenu(stationDetail, stationLocoDetail);' id='station-{{stationDetail?.allocStation}}-loco-{{stationLocoDetail?.locomotive}}'>
                <lms-loco-svg [loco]="convertStationLocoToLocoDetail(stationLocoDetail)" [isYardLocalScreen]='true'></lms-loco-svg>
            </div>
        </div>
    </div>
</div>